import * as React from 'react';
import { IconSVG } from '@bytebrand/fe-ui-core-autobahn/iconsvg';
// ADV-268: opened from the profile page only, so it uses that page's dialog and button styles
// (`.pf-confirm*`, `.pf-btn*` in SettingsPage/ProfilePage.css).
class ConfirmAccountDeleteModal extends React.Component {
    render() {
        const { t, onAccept, onDecline } = this.props;
        return (React.createElement("div", { className: "pf-confirm" },
            React.createElement("span", { className: "pf-confirm-ic", "aria-hidden": "true" },
                React.createElement(IconSVG, { name: 'warningIcon', customDimensions: true })),
            React.createElement("h4", { className: "pf-confirm-title" }, t('confirmAccountDeleteModal.confirmCarDeleteTitle')),
            React.createElement("p", { className: "pf-confirm-desc" }, t('confirmAccountDeleteModal.confirmCarDeleteText')),
            React.createElement("div", { className: "pf-confirm-actions" },
                React.createElement("button", { type: "button", className: "pf-btn pf-btn--outlined", onClick: onDecline }, t('confirmAccountDeleteModal.decline')),
                React.createElement("button", { type: "button", className: "pf-btn pf-btn--destructive", onClick: onAccept }, t('confirmAccountDeleteModal.accept')))));
    }
}
Object.defineProperty(ConfirmAccountDeleteModal, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        onAccept: () => { },
        onDecline: () => { }
    }
});
export default ConfirmAccountDeleteModal;
